<template>
  <ModalDefault modal_id="searchCampaignModal"
                header="y"
                size="modal-lg modal-dialog-scrollable"
                style_header=""
                :modal_header="getTranslations('expression_808')"
                footer="y"
                icon="bx bx-search mr-1">
    <div class="px-2 py-2 pb-3" slot="body">
      <div>
        <div class="d-flex">
          <div class="cursor-default w-100"  style="align-items: center; align-self: center;">
            <div class="d-block pt-0 px-2">
              <div class="row">
                <!--Canais-->
                <div class="col-md-6">
                  <label class="mb-0">{{ getTranslations('expression_4') }} </label>
                  <div class="input-group mb-2">
                    <!--@change="campaigns.fields_search.channel_id ? searchCampaign() : null"-->
                    <select v-model="campaigns.fields_search.channel_id"
                            class="input_forms custom-select pl-50"
                            style="min-width: 200px;">
                      <option :value="null">{{ getTranslations('expression_123') }}</option>
                      <option v-for="channel in channels.data" :key="channel.id" :value="channel.id">{{ channel.name }}</option>
                    </select>
                  </div>
                </div>
                <!--Tipo de campanha-->
                <div class="col-md-6">
                  <label class="mb-0">{{ getTranslations('expression_283') }} </label>
                  <div class="input-group mb-2">
                    <select v-model="campaigns.fields_search.campaign_type"
                            class="input_forms custom-select pl-50"
                            style="min-width: 200px;">
                      <option :value="null">{{ getTranslations('expression_510') }}</option>
                      <option :value="2">HSM</option>
                      <option :value="0">{{ getTranslations('expression_258') }}</option>
                    </select>
                  </div>
                </div>
                <!--Data inicial-->
                <div class="col-md-6">
                  <label class="mb-0"><span class="text-danger">* </span>{{ getTranslations('expression_814') }} </label>
                  <div class="input-group mb-2">
                    <!--@change="campaigns.fields_search.start_date ? searchCampaign() : null"-->
                    <input type="date"
                           required
                           v-model="campaigns.fields_search.start_date"
                           min=""
                           max=""
                           name="add_task_date"
                           :class="errorFieldSearchCampaign ? 'is-invalid' : ''"
                           class="form-control input_forms">
                    <div class="invalid-feedback">
                      Informe uma data inicial
                    </div>
                  </div>
                </div>
                <!--Data final-->
                <div class="col-md-6">
                  <label class="mb-0"> <span class="text-danger">* </span>{{ getTranslations('expression_815') }} </label>
                  <div class="input-group mb-2">
                    <!--@change="campaigns.fields_search.final_date ? searchCampaign() : null"-->
                    <input type="date"
                           required
                           v-model="campaigns.fields_search.final_date"
                           min="" max=""
                           name="add_task_date"
                           :class="errorFieldSearchCampaign ? 'is-invalid' : ''"
                           class="form-control input_forms">
                    <div class="invalid-feedback">
                      Informe uma data final
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="px-2 py-2 d-flex">
      <div>
          <span v-if="this.campaigns.fields_search.campaign_type || this.campaigns.fields_search.channel_id
                      || this.campaigns.fields_search.final_date || this.campaigns.fields_search.start_date"
                data-dismiss="modal"
                @click.prevent="clearSearch"
                class="shadow-sm cursor_pointer animated--grow-in btn-secondary text-white py-2 px-3 mr-2">
            <span class="">{{ getTranslations('expression_810') }}</span>
          </span>
      </div>
      <div>
          <span @click.prevent="searchCampaign"
                class="shadow-sm cursor_pointer animated--grow-in btn-primary text-white py-2 px-3">
            <span class="">{{ getTranslations('expression_811') }}</span>
          </span>
      </div>
    </div>
  </ModalDefault>
</template>

<script>
import ModalDefault from "../../components/general/ModalDefault";
import {mapGetters, mapState} from "vuex";

export default {
  name: "ModalSearchCampaign",
  components: {
    ModalDefault,
  },
  computed: {
    ...mapState(['me','channels', 'campaigns']),
    ...mapGetters([])
  },
  data() {
    return {
      errorFieldSearchCampaign: false,
    }
  },
  methods: {
    clearSearch() {
      this.campaigns.fields_search = {
        channel_id: null,
        campaign_type: null,
        start_date: null,
        final_date: null
      }
      this.campaigns.filter_campaigns_active = false
      this.$store.dispatch("getCampaigns", this.campaigns.fields_search)
      this.$store.dispatch('getCampaignsInfo', this.campaigns.fields_search)
      $(`#searchCampaignModal`).modal('hide')
    },
    searchCampaign(){
      if(this.campaigns.fields_search.start_date && this.campaigns.fields_search.final_date) {
        this.errorFieldSearchCampaign = false

        this.$store.dispatch("getCampaigns", this.campaigns.fields_search)
        this.$store.dispatch('getCampaignsInfo', this.campaigns.fields_search)
        this.campaigns.filter_campaigns_active = true
        $(`#searchCampaignModal`).modal('hide')
      } else {
        this.errorFieldSearchCampaign = true
      }
    },
  }
}
</script>

<style scoped>

</style>
